import React from 'react';
import { Icon } from 'kl-b2c-ui-kit';
import { useTranslation } from 'react-i18next';
import {
    CWrap,
    Image,
    Title,
    Link2Item,
    ArrowIcon,
    Go2DetailedBtn,
    Tag,
} from './styled';

export interface EventListItem {
    imageURL: string;
    title: string;
    link: string;
}

export interface Props {
    data: EventListItem;
    isFirstInBlock: boolean;
    secondary?: boolean;
    date?: string;
    target?: string;
    isAcademy?: boolean;
}

export const EventCard: React.FC<Props> = ({
    data: { imageURL, title, link },
    isFirstInBlock,
    secondary,
    date,
    target,
    isAcademy,
}): JSX.Element => {
    const { t } = useTranslation('pages/events');

    return (
        <CWrap
            className={isFirstInBlock ? 'isFirst' : ''}
            isAcademy={isAcademy}>
            {date && (
                <Tag past={Date.now() > new Date(date).getTime()}>
                    {Date.now() < new Date(date).getTime()
                        ? t('future')
                        : t('past')}
                </Tag>
            )}
            <Link2Item
                className={isFirstInBlock ? 'isFirst' : ''}
                to={link}
                target={target}
                isAcademy={isAcademy}>
                <Image
                    className={isFirstInBlock ? 'isFirst' : ''}
                    isAcademy={isAcademy}>
                    <img
                        src={imageURL}
                        alt={title}
                        style={{ borderRadius: '16px' }}
                    />
                </Image>
                <Title
                    className={isFirstInBlock ? 'isFirst' : ''}
                    secondary={secondary}>
                    {title}
                </Title>
                <Go2DetailedBtn isAcademy={isAcademy}>
                    {t('moreCaption')}
                    <ArrowIcon>
                        <Icon name={'ArrowRight'} color={'primary'} size={24} />
                    </ArrowIcon>
                </Go2DetailedBtn>
            </Link2Item>
        </CWrap>
    );
};

export default React.memo(EventCard);
